import { TYPE_NONE } from "@components/Form";

type UpdateInput = {
  name: "mobile" | "givenName" | "familyName";
  type?: typeof TYPE_NONE;
};

const getUpdateInputs = (): UpdateInput[] => {
  return [
    { name: "mobile" },
    { name: "givenName", type: TYPE_NONE },
    { name: "familyName", type: TYPE_NONE },
  ];
};

export default getUpdateInputs;
